export default [
  {
    id: 1,
    ch: '为彩票从业者提供增值业务',
    en: 'Provide value-added service for lottery practitioners',
    color: '#FFFFFF'
  },
  {
    id: 2,
    ch: '为彩票从业者提供营销物料及培训',
    en: 'Provide marketing materials and training for lottery practitioners',
    color: '#8B5B21'
  },
  {
    id: 3,
    ch: '为彩票从业者及彩民提供赛事资讯、赛事数据、赛事分析等服务',
    en: 'Provide services such as event information, event data and event analysis for lottery practitioners and lottery players.',
    color: '#FFFFFF'
  }
]
